import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectCoverflow, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

// Imágenes para Programas
/*import utiles1 from '../assets/entregaUtiles1.jpg';
import viveres from '../assets/entregaViveres.jpg';
import musica from '../assets/claseMusica.jpg';
import feriaSalud from '../assets/feriaSalud.jpg';
import revisionMedica from '../assets/revisionMed.jpg';
import fondoProgramas from '../assets/fondoProgramas.jpg';// imagenes antiguas 2024*/
import donacionBilias from '../assets/donacionBiblias.jpeg';
import graduacion from '../assets/graduacionComputacion.jpeg';
import musica from '../assets/musica.jpeg';
import reposteriaMadres from '../assets/reposteriaMadres.jpeg';
import vale from '../assets/vale.jpeg';
import fondoProgramas from '../assets/fondoProgramas.jpg';
// Imágenes para Coverflow

/*import almuerzo from '../assets/almuerzo.jpg';
import poleras from '../assets/entregaPoleras.jpg';
import navidad from '../assets/entregaNavidad.jpg';
import padres from '../assets/tallerPadres.jpg';
import campamento from '../assets/campamentoJovenes.jpg';// imagenes antiguas 2024*/
import capacitacion from '../assets/capacitacionTecnica1.jpeg'
import confraJuvenil from '../assets/confraJuvenil.jpeg'
import retiroPlanDeVida from '../assets/retiroPlanDeVida.jpeg'
import compromisoPureza from '../assets/compromisoPureza.jpeg'
import clubDeAdolescentes from '../assets/clubDeAdolescentes.jpeg'
import tallerProteccionInfantil from '../assets/tallerProtecciónInfantil.jpeg'
import trabajoEnEquipo from '../assets/trabajoEnEquipo.jpeg'
import clasesDeOratoria from '../assets/clasesDeOratoria.jpeg'
import campamentoNinos from '../assets/campamentoNinos.jpeg'
import consursoBiblico from '../assets/concursoBiblico.jpeg'
import barbería from '../assets/barberia.jpeg'
import campamento2025 from '../assets/campamento2025.jpeg'
import alimentos from '../assets/alimentos.jpeg'




const Programas = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const portfolios = [
    {
      id: 1,
      src: donacionBilias,
      titulo1: 'Donación de Biblias',
      titulo2: 'Fundación la Victoria',
      href: '',
    },
    {
      id: 2,
      src: graduacion,
      titulo1: 'Graduación de Computación',
      titulo2: 'Fundación la Victoria',
      href: '',
    },
    {
      id: 3,
      src: alimentos,
      titulo1: 'Entrega de Alimentos a Familias',
      titulo2: 'Fundación la Victoria',
      href: '',
    },
    {
      id: 4,
      src: reposteriaMadres,
      titulo1: 'Repostería para madres',
      titulo2: 'Fundación la Victoria',
      href: '',
    },
    {
      id: 5,
      src: vale,
      titulo1: 'Vales como incentivo',
      titulo2: 'Fundación la Victoria',
      href: '',
    },
    
  ];

  /*const destinations = [
    {
      title: 'Almuerzo',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      image: almuerzo,
    },
    {
      title: 'Entrega de Poleras',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      image: poleras,
    },
    {
      title: 'Regalo de Navidad',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      image: navidad,
    },
    {
      title: 'Taller de protección para padres',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      image: padres,
    },
    {
      title: 'Devocional en Campamento',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      image: campamento,
    },
  ];//versión antigua 2024*/
  const destinations = [
    {
      title: 'Capacitación técnica',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      objetivo:'Brindar a los jóvenes de la fundación conocimientos y habilidades básicas en repostería, fortaleciendo su capacitación técnica para fomentar el emprendimiento.',
      resultado:'jóvenes con animos y ganas de emprender',
      image: capacitacion,
    },
    {
      title: 'Confraternización con ministerio Juvenil',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      objetivo:'Impulsar su liderazgo a través de roles que deben realizar y dirigir en el tiempo designado',
      resultado:'Jóvenes que sirvan y sean auto independientes para dirigir su propio grupo.',
      image: confraJuvenil,
    },
    {
      title: 'Retiro por culminación de plan de vida',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      objetivo:'Los adolescentes participan de un retiro y disfrutan de juegos y piscina como incentivo por su responsabilidad.',
      resultado:'Mayor número de planes de vida concluidos por los adolescentes.',
      image: retiroPlanDeVida,
    },
    {
      title: 'Compromiso de Pureza',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      objetivo:'Fomentar un compromiso de pureza que honre a Dios y fortalezca la vida espiritual de los creyentes.',
      resultado:'Más de 30 jóvenes realizaron su compromiso de pureza ante Dios',
      image: compromisoPureza,
    },
    {
      title: 'Club de Adolescentes',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      objetivo:'Compartir las buenas noticias y el amor de Cristo con todos los adolescentes.',
      resultado:'Adolescentes transformados por Cristo.',
      image: clubDeAdolescentes,
    },
    {
      title: 'Taller para padres sobre la protección infantil.',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      objetivo:'Informar a los padres sobre la importancia de la protección a los niños y también realizar una exposición donde los participantes den a conocer sobre el tema a todos los padres.',
      resultado:'Padres capacitados en protección a la niñez y participantes con conocimiento en el tema.',
      image: tallerProteccionInfantil,
    },
    {
      title: 'Trabajo en Equipo ',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      objetivo:'Fortalecer la unidad entre compañeros y el manejo de trabajos grupales.',
      resultado:'Más unidad entre compañeros y valores de equipos reforzados.',
      image: trabajoEnEquipo,
    },
    {
      title: 'Clases de oratoria para adolescentes',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      objetivo:'Impulsar su desarrollo para que mejoren en su oratoria y les ayude a ser más seguros al hablar.',
      resultado:'Adolescentes capacitados en oratoria.',
      image: clasesDeOratoria,
    },
    {
      title: 'Campamento kids "Fortaleciendo mis lazos de amor"',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      objetivo:'Que los niños y padres tengan un tiempo de calidad entre ellos, con sigo mismo y con Dios, reconociendo que la familia es pilar Fundamental y Dios es la fuente de todo amor.',
      resultado:'Familias transformadas en el amor de Dios',
      image: campamentoNinos,
    },
     {
      title: 'Concurso Bíblico "Triunfadores 6-11"',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      objetivo:'Fundamentar mas la palabra de Dios, con principios y valores bíblicos, para que sean agentes de cambio en nuestra comunidad.',
      resultado:'Niños mas preparados en la palabra de Dios',
      image: consursoBiblico,
    },
     {
      title: 'Capacitación técnica en carrera de barbería',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      objetivo:'Los jóvenes recibieron apoyo en capacitación técnica en carrera de barbería',
      resultado:'Actualmente ellos ya están generando ingresos económicos',
      image: barbería,
    },
      {
      title: 'Campamento Metanoia 2025 ',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      objetivo:'Motivar a los participantes a un cambio de mentalidad que les permita transformar su vida personal y espiritual.',
      resultado:'Los participantes reflexionaron sobre sus actitudes, fortalecieron su fe y asumieron el compromiso de iniciar cambios positivos en su vida.',
      image: campamento2025,
    },
    {
      title: 'Clases de música para jovenes',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      objetivo:'Apoyar al talento de los jóvenes en la música',
      resultado:'Jovenes aprendiendo a tocar instrumentos musicales',
      image: musica,
    },
    
    /*{
      title: 'Entrega de Poleras',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      image: poleras,
    },
    {
      title: 'Regalo de Navidad',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      image: navidad,
    },
    {
      title: 'Taller de protección para padres',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      image: padres,
    },
    {
      title: 'Devocional en Campamento',
      category: 'Fundación la Victoria',
      location: 'Fundación la Victoria',
      image: campamento,
    },*/
  ];

  return (
    <div className="w-full">
      {/* Sección Programas */}
      <div
        name="programas"
        className="bg-green-two text-white"
        style={{ backgroundImage: `url(${fondoProgramas})` }}
      >
        <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
          <div className="pb-8 flex flex-col justify-center items-center">
            <p className="text-5xl text-blue-one font-montserrat inline justify-center border-b-4 border-blue-two">
              Actividades
            </p>
          </div>

          {isMobile ? (
            <Swiper
              modules={[Autoplay]}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              loop={true}
              spaceBetween={10}
              slidesPerView={1}
              className="w-full"
            >
              {portfolios.map(({ id, src, titulo1, titulo2, href }) => (
                <SwiperSlide key={id}>
                  <div
                    className="shadow-md shadow-gray-600 rounded-lg overflow-hidden"
                    onClick={() => window.open(href, '_blank')}
                  >
                    <img
                      src={src}
                      alt=""
                      className="w-full h-80 object-contain "
                    />
                    <div className="text-center mt-2 px-2">
                      <p className="text-lg font-semibold text-blue-one" >{titulo1}</p>
                      <p className="text-sm text-blue-two">{titulo2}</p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="grid sm:grid-cols-2 md:grid-cols-5 gap-4 px-12 sm:px-0">
              {portfolios.map(({ id, src, titulo1, titulo2, href }) => (
                <div
                  key={id}
                  className="shadow-md shadow-gray-600 rounded-lg overflow-hidden"
                  onClick={() => window.open(href, '_blank')}
                >
                  <img
                    src={src}
                    alt=""
                    className="w-full h-80 object-cover"
                  />
                  <div className="text-center mt-2 px-2">
                    <p className="text-lg font-semibold text-blue-one">{titulo1}</p>
                    <p className="text-sm text-blue-two">{titulo2}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Sección Carrusel tipo Coverflow */}
      
<div
  className="w-full py-10 px-5"
  style={{ backgroundImage: `url(${fondoProgramas})` }}
>
  <Swiper
    effect="coverflow"
    grabCursor={true}
    centeredSlides={true}
    slidesPerView="auto"
    loop={true}
    autoplay={{ delay: 6000 }}
    coverflowEffect={{
      rotate: 0,
      stretch: 0,
      depth: 150,
      modifier: 2.5,
      slideShadows: false,
    }}
    pagination={{ clickable: true }}
    modules={[EffectCoverflow, Pagination, Autoplay]}
    className="w-full max-w-5xl mx-auto"
  >
    {destinations.map((item, index) => (
      <SwiperSlide
        key={index}
        // ancho dinámico: más grande en PC para que entren 2 columnas cómodas
        className="w-80 md:w-[820px]"
      >
        <div className="bg-white rounded-xl overflow-hidden shadow-lg">
          {/* Responsive: mobile columna | md+ 2 columnas */}
          <div className="flex flex-col md:flex-row">
            {/* Columna imagen */}
            <div className="w-full md:w-1/2 flex items-center justify-center bg-white">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-56 md:h-72 object-contain p-3"
              />
            </div>

            {/* Columna texto (3 párrafos) */}
            <div className="w-full md:w-1/2 p-5 md:p-8 flex flex-col justify-center">
              <h3 className="text-2xl font-bold text-blue-one mb-4">
                {item.title}
              </h3>

              <div className="space-y-4 text-sm md:text-base text-gray-700">
                <p>
                  <span className="font-semibold text-blue-two">
                    Actividad:{' '}
                  </span>
                  {item.title}
                </p>

                <p>
                  <span className="font-semibold text-blue-two">
                    Objetivo:{' '}
                  </span>
                  {item.objetivo ?? 'Reemplaza este texto por el objetivo real.'}
                </p>

                <p>
                  <span className="font-semibold text-blue-two">
                    Resultado:{' '}
                  </span>
                  {item.resultado ?? 'Reemplaza este texto por el resultado real.'}
                </p>
              </div>

              {/* Si quieres mantener category como “subtítulo” */}
              <p className="mt-6 text-xs md:text-sm text-blue-500 font-semibold">
                {item.category}
              </p>
            </div>
          </div>
        </div>
      </SwiperSlide>
    ))}
  </Swiper>
</div>


    </div>
  );
};

export default Programas;
